import { Action, createSlice, PayloadAction, ThunkAction } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

export type StatisticalComparisonFiltersState = {
    metric: string;
    comparing: string;
    comparingWith: string;
    samplingYear: string;
    shouldShowBoxPlot: boolean;
    shouldShowSamplePoints: boolean;
};

const defaultFiltersState = {
    metric: '',
    comparing: '',
    comparingWith: '',
    samplingYear: '',
    shouldShowBoxPlot: true,
    shouldShowSamplePoints: true,
};

export type StatisticalComparisonUIState = {
    filters: StatisticalComparisonFiltersState;
};

export const defaultUiState = {
    filters: { ...defaultFiltersState },
};

type StatisticalComparisonState = {
    uiState: {
        [projectId: string]: StatisticalComparisonUIState;
    };
};
const initialState: StatisticalComparisonState = {
    uiState: {},
};

export const updateFilters =
    (fragment: Partial<StatisticalComparisonFiltersState>): ThunkAction<void, RootState, void, Action<string>> =>
    (dispatch, getState) => {
        const state = getState();

        const projectId = state.projects.projectList.currentProjectId;

        if (projectId) {
            dispatch(
                StatisticalComparisonSlice.actions.updateFilters({
                    projectId,
                    fragment,
                })
            );
        }
    };

const ensureProjectUIStatePresence = (state: StatisticalComparisonState, projectId: string) => {
    if (!state.uiState[projectId]) {
        state.uiState[projectId] = {
            filters: { ...defaultFiltersState },
        };
    }
};

const StatisticalComparisonSlice = createSlice({
    name: 'StatisticalComparison',
    initialState,
    reducers: {
        updateFilters(state, action: PayloadAction<{ projectId: string; fragment: Partial<StatisticalComparisonFiltersState> }>) {
            const { projectId, fragment } = action.payload;

            ensureProjectUIStatePresence(state, projectId);

            state.uiState[projectId].filters = {
                ...(state.uiState[projectId].filters as StatisticalComparisonFiltersState),
                ...fragment,
            };
        },
    },
});

export default StatisticalComparisonSlice.reducer;
